"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _clsx2 = _interopRequireDefault(require("clsx"));
var _pfaHero = _interopRequireDefault(require("./pfa-hero.css"));
var _pfaHero2 = _interopRequireDefault(require("./pfa-hero.props/pfa-hero.defaultProps"));
var _pfaHero3 = _interopRequireDefault(require("./pfa-hero.props/pfa-hero.propTypes"));
var _pfaHeroTextBlock = _interopRequireDefault(require("./pfa-hero-text-block"));
// We use the same default props for data and defaultData
// This keeps our PropTypes and DefaultProps objects nice and clean and non repeating

var applyDarkTheme = function applyDarkTheme(data, theme) {
  return data.theme === 'dark' ? theme[data.theme] : '';
};
var PFAHeroBackground = /*#__PURE__*/function (_React$Component) {
  function PFAHeroBackground(props) {
    return _React$Component.call(this, props) || this;
  }
  (0, _inheritsLoose2["default"])(PFAHeroBackground, _React$Component);
  var _proto = PFAHeroBackground.prototype;
  _proto.render = function render() {
    var _clsx;
    var _this$props = this.props,
      data = _this$props.data,
      theme = _this$props.theme;
    var _ref = data || {},
      image = _ref.backgroundImage.image,
      contentAlignment = _ref.contentAlignment,
      logoURL = _ref.logoURL,
      isCarousel = _ref.isCarousel,
      mobileImage = _ref.mobileImage.image,
      variation = _ref.pfaVersion;
    var backgroundImageAltText = data.backgroundImage.altText || 'Mitsubishi Motors Image';
    return /*#__PURE__*/_react["default"].createElement("article", {
      style: {
        backgroundImage: "url(" + image + ")"
      },
      className: (0, _clsx2["default"])(_pfaHero["default"]['hero-wrapper'], _pfaHero["default"][variation], _pfaHero["default"][contentAlignment], (_clsx = {}, _clsx[_pfaHero["default"].isCarousel] = isCarousel, _clsx))
    }, /*#__PURE__*/_react["default"].createElement(_pfaHeroTextBlock["default"], {
      theme: theme,
      data: data,
      isCarousel: isCarousel
    }), /*#__PURE__*/_react["default"].createElement("img", {
      className: (0, _clsx2["default"])(_pfaHero["default"].imageBackground, _pfaHero["default"].mobile),
      fetchpriority: "high",
      src: mobileImage,
      alt: backgroundImageAltText
    }));
  };
  return PFAHeroBackground;
}(_react["default"].Component);
PFAHeroBackground.displayName = 'PFAHeroBackground';
PFAHeroBackground.defaultProps = {
  data: _pfaHero2["default"]
};
var _default = exports["default"] = PFAHeroBackground;